<template>
  <section class="whell-fortune__page-wrapper">
    <div v-animation:left class="whell-fortune__cube whell-fortune__cube--left" aria-label="Декор куб слева"></div>
    <div v-animation:right class="whell-fortune__cube whell-fortune__cube--right" aria-label="Декор куб справа"></div>
    <div class="whell-fortune t-container">
      <div class="whell-fortune__hero whell-fortune-hero" v-animation:bottom.delay>
        <div class="hero__brand">
          <img class="hero__logo" src="/dist/img/ax-max-pro/logo_maximum_pro.svg" alt="Maximum PRO" />
        </div>

        <div class="hero__right">
          <img class="hero__sticker" src="/dist/img/ax-max-pro/sticker.svg" alt="AXOFT MAXIMUM PRO" aria-hidden="true" />
        </div>
      </div>

      <div class="whell-fortune__stage">
        <wheel-fortune
          v-if="!gift"
          image="/dist/img/ax-max-pro/wheel-fortune/fortuneOffline.svg"
          @win="setGift"
        ></wheel-fortune>
        <template v-else>
          <div class="whell-fortune__card">
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.secretPrize">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/secretPrize.png" alt="secretPrize">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Суперсекретный приз».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.simpleWineGiftCertificate">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/simpleWineGiftCertificate.png" alt="simpleWineGiftCertificate">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарочный сертификат Simple Wine».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirFlant">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/souvenirFlant.png" alt="souvenirFlant">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарок от вендора Флант».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirPhishman">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/souvenirPhishman.png" alt="souvenirPhishman">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарок от вендора Phishman».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.yaPlus">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/yaPlus.png" alt="yaPlus">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подписка Яндекс Плюс». Сертификат будет направлен в течение трех дней на e-mail, указанный при регистрации.</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.souvenirAstraGroup">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/souvenirAstraGroup.png" alt="souvenirAstraGroup">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарок от вендора Группа Астра».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.paperStickerPack">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/paperStickerPack.png" alt="paperStickerPack">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Подарочный стикерпак Axoft».</p>
              <p>Пусть радость победы вдохновляет вас на новые свершения, улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
            </template>
            <template v-if="gift === OFFLINE_WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack">
              <img class="whell-fortune__prize-img" src="/dist/img/ax-max-pro/wheel-fortune/tgStickerPack.png" alt="tgStickerPack">
              <p>Поздравляем! Сегодня ваш счастливый день: вы выиграли «Стикерпак для телеграм Axoft». Пусть радость победы вдохновляет вас на новые свершения,  улыбка не покидает ваше лицо весь день! Удачи вам и новых побед!</p>
              <img class="whell-fortune__prize-qr-img" src="/dist/img/ax-max-pro/wheel-fortune/tgStickerQr.png" alt="tgStickerQr">
            </template>
            <div class="t-btn _green _big" @click="() => { gift = null }">Крутить снова</div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue"
import AmpWheelFortune from "./components/amp-wheel-fortune.vue"
import { observeNewAnimateBlocks } from "@src/libs/animate/scroll.animate"
import { OFFLINE_WHEEL_FORTUNE_PRIZE_MAP } from "@pages/axoft-wheel-fortune/consts/wheelFortune"

export default {
  name: "axoft-whell-fortune",
  components: {
    "wheel-fortune": AmpWheelFortune,
  },
  props: {
  },
  data() {
    return {
      gift: null
    }
  },
  mounted() {
    setTimeout(() => {
      observeNewAnimateBlocks()
    }, 1100)
  },
  computed: {
    OFFLINE_WHEEL_FORTUNE_PRIZE_MAP() {
      return OFFLINE_WHEEL_FORTUNE_PRIZE_MAP
    },
  },
  methods: {
    async setGift(gift) {
      this.gift = gift

      await Vue.http.post('/api/events/setPrize', {
        email: 'offline_user',
        slug: gift,
        type: 'offline'
      })
    },
  },
}
</script>

<style lang="sass">
@import "~@src/sass/params"

$card: #ffffff
$ink: #0f172a
$accent: #1AB8C4
$border: #e5e7eb
$radius: 6px

.t-page_axoft-wheel-fortune
  min-height: 100%
  background: $dark-blue
  overflow-x: hidden
  padding-block: 130px 121px

@keyframes spin-cube
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.whell-fortune
  $row-gap: 42px

  position: relative
  color: $ink

  &__hero
    margin: 0 auto

  &__cube
    position: absolute
    width: 197px
    height: 197px
    background-repeat: no-repeat
    background-size: cover
    z-index: 10

    &:hover
      animation-name: spin-cube
      animation-duration: 5000ms
      animation-iteration-count: infinite
      animation-timing-function: linear

    &--left
      top: 40%
      left: -70px
      background-image: url("/dist/img/ax-max-pro/cube.png")

    &--right
      bottom: 15%
      right: -40px
      background-image: url("/dist/img/ax-max-pro/cube_2.png")

  &__stage
    margin-top: 34px
    margin-bottom: $row-gap
    display: flex
    justify-content: center
    margin-inline: 10px

  &__card
    display: flex
    gap: 20px
    flex-direction: column
    border-radius: 6px
    background-color: #FFFFFF
    max-width: 700px
    margin-inline: 10px
    padding: 54px 30px 86px 68px

    @media (max-width: $tablet-size)
      padding: 20px

    > p
      font-size: 18px

    > .t-btn
      margin-top: 10px
      width: auto
      align-self: center

  &__prize-img
    width: 160px
    margin-bottom: 40px
    align-self: center

    @media (max-width: $tablet-size)
      margin-bottom: 20px

  &__prize-qr-img
    width: 152px
    align-self: center

/* ===== HERO ===== */
.whell-fortune-hero
  display: flex
  align-items: center
  justify-content: space-between
  gap: 16px

  &__brand
    display: flex
    flex-direction: column
    gap: 58px
    margin-top: 25px
    margin-left: 25px
    flex-shrink: 1

  &__logo
    display: block
    width: 400px

  &__right
    flex-basis: 45%
    flex-shrink: 1

  &__sticker
    width: 580px
    filter: drop-shadow(0 6px 16px rgba(0, 0, 0, .35))

/* ====== ADAPTIVE ====== */

@media (max-width: $tablet-header)
  .t-page_axoft-wheel-fortune
    padding-block-start: 80px

@media (max-width: $tablet-size)
  .whell-fortune__stage
    margin-top: 25px
    margin-bottom: 25px

@media (max-width: $mobile-size)
  .t-page_axoft-wheel-fortune
    padding-top: 80px

  .wheel-fortune
    padding-block-start: 60px

  .whell-fortune__cube, .hero__right
    display: none

  .whell-fortune-hero
    justify-content: center

    &__brand
      padding-inline: 16px
      align-items: center
      margin-top: unset
      margin-left: unset
      justify-content: center
      gap: 12px

    &__logo
      width: 212px

    &__stage
      margin-top: 40px

</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-wheel-fortune/index.vue